import { render, staticRenderFns } from "./DoroImage.vue?vue&type=template&id=ee8133bc&functional=true&"
import script from "./DoroImage.vue?vue&type=script&lang=ts&"
export * from "./DoroImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports